import { ConsoleRequest, DataProviderType } from '../../utils/request';
import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { CompanyData } from '../common/types/CompanyData';

export class UserFormSelectedCompanyDataProvider extends BaseWebComponentDataProvider {
  async getUserFormSelectedCompanyData(companyId: string): Promise<CompanyData> {
    return await ConsoleRequest.createRequest<CompanyData>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Company',
      method: 'getUserFormSelectedCompanyData',
      payload: {
        companyId: companyId,
      },
    });
  }
}
